<template>
    <v-card class="tournaments__box" :to="{ name: 'tournamentDetail', params: { id: tournament.id } }">        
        <v-row>
            <v-col cols="16" sm="10" md="12">
                <v-card-title>
                    <p class="tournaments__name">{{ tournament.name }}</p>
                </v-card-title>
            </v-col>
            <v-col cols="16" sm="6" md="4" class="rightcenter tournaments__date">
                <v-card-text><p>{{ tournament.start | formatDay }} - {{ tournament.end | formatDay }}</p></v-card-text>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
    export default {
        name: 'TournamentItem',
        props: {
            tournament: {
                type: Object,
                required: true,
            },
        },
    }
</script>
